<template>
    <div class="d-flex align-items-center">
        <span class="d-flex mr-2"> {{ name }}</span>
        <span @click="copyToClipboard">
            <font-awesome-icon class="copy-icon" :icon="['fas', 'copy']" />
        </span>
    </div>
</template>

<script>
export default {
    computed: {
        name() {
            return this.params && this.params.data.number;
        },
    },
    methods: {
        async copyToClipboard() {
            const text = this.name;
            try {
                await navigator.clipboard.writeText(text);
                this.successToast({
                    text: 'Copied to clipboard successfully.',
                });
            } catch (err) {
                this.errorToast({
                    text: 'Something went wrong while copying to clipboard.',
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.copy-icon {
    transition: 0.4s;
    cursor: pointer;
    &:hover {
        color: #cdcdcd;
    }
}
</style>